/**
 *  Created by piotr@revisual.io on 12/08/2025
 */
import { useEffect } from "react";
/**
 * Custom hook to handle visibility change events in a React application.
 *
 * @param {Function} callback - The function to call when the visibility changes.
 * @param {Array} deps - Dependencies for the useEffect hook.
 */
export const useVisibilityHook = (callback, deps) => {
  useEffect(() => {
    const onVisabilityChange = () => {
      callback();
    };
    window.addEventListener("visibilitychange", onVisabilityChange);

    return () => {
      window.removeEventListener("visibilitychange", onVisabilityChange);
    };
  }, [deps, callback]);
};

export default useVisibilityHook;
